import styled from 'styled-components';

import { basicBodyTextStyle } from '@dreryk/react-components';
export const StyledGuardianSelectPesel = styled.div`
   ${basicBodyTextStyle}
   color: ${(props) => props.theme.backgroundDark};
`;
StyledGuardianSelectPesel.displayName = 'StyledGuardianSelectPesel';
